<ng-container *transloco="let t">
  <p-fileUpload
    #fileUpload
    accept=""
    name="myfile[]"
    [customUpload]="true"
    [disabled]="disabled()"
    [maxFileSize]="maxFileSize()"
    [multiple]="multiple()"
    [showCancelButton]="false"
    [showUploadButton]="false"
    (onSelect)="onSelectedFiles($event)">
    <ng-template pTemplate="content">
      <div class="upload-info">
        <div
          class="upload-info-wrapper"
          [ngClass]="{ 'upload-info-wrapper--standard': standardLayout() }">
          <i class="pi pi-cloud-upload upload-info-wrapper__icon"></i>
          <div class="upload-info-wrapper__text">
            <p>{{ t('selectFileDragDrop') }}</p>
            <p>{{ t(helperText()) }}</p>
          </div>
        </div>
        <div class="upload-info-divider">
          {{ t('or') }}
        </div>
        <shared-button
          class="file-upload-outline-button"
          [isDisabled]="disabled()"
          [label]="t('selectFile')"
          [pt]="addDocumentButtonPT"
          [type]="sharedButtonType.Outline"
          (clickEvent)="choose(fileUpload)">
        </shared-button>
      </div>
      @if (files().length > 0) {
        <div class="files-list">
          <div class="files-list__header">{{ t('fileName') }}</div>
          @for (file of files(); track file; let i = $index; let odd = $odd) {
            <div
              class="files-list__item"
              [ngClass]="{ 'files-list__odd': odd }">
              <div class="files-list__info">
                <span class="files-list__info-name">
                  {{ file.name }}
                </span>
                <ng-container
                  *ngTemplateOutlet="errorsTemplate(); context: { $implicit: file, errors: errors().get(file.name) ?? [] }">
                </ng-container>
              </div>
              <span class="files-list__item-remove">
                <i
                  class="pi pi-trash"
                  role="button"
                  style="font-size: 1.5rem"
                  tabindex="0"
                  [ariaLabel]="t('delete') + file.name"
                  (click)="removeFile($event, fileUpload, i)"
                  (keydown.enter)="removeFile($event, fileUpload, i)"
                  (keydown.space)="removeFile($event, fileUpload, i)">
                </i>
              </span>
            </div>
          }
        </div>
      }
    </ng-template>
  </p-fileUpload>
</ng-container>